export const MANAGE_REVENUE_SPLIT_KEYS = {
  office: "office",
  sales: "sales",
  counseling: "counseling",
  affiliateRoyalty: "affiliateRoyalty",
  royaltyRetention: "royaltyRetention",
  total: "total",
};

export const MANAGE_REVENUE_SPLIT_INLINE_FORM_KEYS = {
  COUNSELING: "counseling",
} as const;

export const MANAGE_REVENUE_SPLIT_ROW_ORDER = {
  CORPORATE: 1,
  SALES: 2,
  COUNSELLING_EDITABLE: 3,
  TOTAL: 4,
};

export const COUNSELLING_EDITABLE_RELATIONSHIP_TYPES = {
  AFFILIATE_AFFILIATE: "RelationshipType.Affiliate-Affiliate",
  AFFILIATE_RMCI: "RelationshipType.Affiliate-RMCI",
  RMCI_AFFILIATE: "RelationshipType.RMCI-Affiliate",
  RMCI_RMCI: "RelationshipType.RMCI-RMCI",
} as const;

export const COUNSELLING_EDITABLE_RELATIONSHIP_TYPES_ARRAY = Object.values(
  COUNSELLING_EDITABLE_RELATIONSHIP_TYPES,
);

export type CounsellingEditableRelationshipType =
  (typeof COUNSELLING_EDITABLE_RELATIONSHIP_TYPES)[keyof typeof COUNSELLING_EDITABLE_RELATIONSHIP_TYPES];
